module.exports = {"654028100":"尼勒克镇","654028200":"苏布台乡","654028201":"喀拉苏乡","654028202":"加哈乌拉斯台乡","654028203":"尼勒克县乌赞乡","654028204":"科克浩特浩尔蒙古民族乡","654028205":"乌拉斯台乡","654028206":"克令乡","654028207":"喀拉托别乡","654028208":"胡吉尔台乡","654028209":"木斯乡","654028402":"尼勒克马场","654028404":"种蜂场","654028518":"兵团七十九团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654028.json
// module id = 2918
// module chunks = 0